import { useTranslation } from 'react-i18next'
import type { QuickSuggestionProps } from '@/types/chatbot'

export function QuickSuggestions({
  suggestions,
  onSelect,
  disabled,
}: QuickSuggestionProps) {
  const { t } = useTranslation('common')

  return (
    <div className="flex flex-wrap gap-2 justify-center">
      {suggestions.map((suggestion) => (
        <button
          key={suggestion.id}
          onClick={() => onSelect(suggestion.messageKey)}
          disabled={disabled}
          className="px-4 py-2 text-xs bg-[var(--color-graphite)] hover:bg-[var(--color-steel)] text-[var(--color-fog)] rounded-lg transition-colors disabled:opacity-50 border border-[var(--color-steel)] hover:border-[var(--accent-primary)]"
        >
          {t(suggestion.labelKey)}
        </button>
      ))}
    </div>
  )
}
